import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class BundledDownloadsBaseComponent extends BaseComponent {
  public text: string = "BundledDownloads";

  constructor(userService: UserService) {
    super(userService);
  }
}
